// extracted by mini-css-extract-plugin
module.exports = {"reviewRating":"ReviewRating_reviewRating__HNHOJ","reviewRatingMain":"ReviewRating_reviewRatingMain__TZd_L"};